import api from './api';

const SC = (t) => `/api/schedule/c/${t}`;
const SH = (t) => `/api/shared/ai-report/${t}`;
const sess = (s) => (s ? { headers: { 'X-Share-Session': s } } : {});

export const schedulingAPI = {
  me: () => api.get('/api/scheduling/me'),
  saveAvailability: (data) => api.put('/api/scheduling/me/availability', data),
  team: () => api.get('/api/scheduling/team'),
  pools: () => api.get('/api/scheduling/pools'),
  createPool: (data) => api.post('/api/scheduling/pools', data),
  updatePool: (id, data) => api.put(`/api/scheduling/pools/${id}`, data),
  deletePool: (id) => api.delete(`/api/scheduling/pools/${id}`),
  poolSlots: (id, params) => api.get(`/api/scheduling/pools/${id}/slots`, { params }),
  poolPreview: (id, params) => api.get(`/api/scheduling/pools/${id}/preview`, { params }),
  list: (params = {}) => api.get('/api/scheduling/interviews', { params }),
  get: (id) => api.get(`/api/scheduling/interviews/${id}`),
  create: (data) => api.post('/api/scheduling/interviews', data),
  reschedule: (id, data) => api.post(`/api/scheduling/interviews/${id}/reschedule`, data),
  cancel: (id, reason) => api.post(`/api/scheduling/interviews/${id}/cancel`, { reason }),
  outcome: (id, data) => api.post(`/api/scheduling/interviews/${id}/outcome`, data),
  resend: (id) => api.post(`/api/scheduling/interviews/${id}/resend`),
  syncCalendar: (id) => api.post(`/api/scheduling/interviews/${id}/sync-calendar`),
  ics: (id) => api.get(`/api/scheduling/interviews/${id}/ics`, { responseType: 'blob' }),
  jobCandidates: (jobId) => api.get(`/api/jobs/${jobId}/ai-interview-candidates`),
  connectCalendar: (provider) => api.get(`/api/calendar/${provider}/connect`),
  disconnectCalendar: (provider) => api.delete(`/api/calendar/${provider}`),
};

export const candidateScheduleAPI = {
  context: (t) => api.get(SC(t)),
  slots: (t) => api.get(`${SC(t)}/slots`),
  book: (t, data) => api.post(`${SC(t)}/book`, data),
  cancel: (t, reason) => api.post(`${SC(t)}/cancel`, { reason }),
  icsUrl: (t) => `${process.env.REACT_APP_BACKEND_URL}${SC(t)}/ics`,
};

export const shareAPI = {
  list: (iid) => api.get(`/api/ai-interviews/${iid}/shares`),
  create: (iid, data) => api.post(`/api/ai-interviews/${iid}/shares`, data),
  revoke: (iid, sid) => api.post(`/api/ai-interviews/${iid}/shares/${sid}/revoke`),
  view: (t, s) => api.get(SH(t), sess(s)),
  requestCode: (t, email) => api.post(`${SH(t)}/request-code`, { email }),
  verify: (t, email, code) => api.post(`${SH(t)}/verify`, { email, code }),
  recordingParts: (t, s) => api.get(`${SH(t)}/recording`, sess(s)),
  recording: (t, s, part) => api.get(`${SH(t)}/recording/${part}`, { ...sess(s), responseType: 'blob' }),
};

export const SCHED_STATUS = {
  awaiting_candidate: { label: 'Awaiting candidate', tone: 'amber' },
  scheduled: { label: 'Scheduled', tone: 'teal' },
  completed: { label: 'Completed', tone: 'green' },
  no_show: { label: 'No-show', tone: 'red' },
  cancelled: { label: 'Cancelled', tone: 'slate' },
  expired: { label: 'Link expired', tone: 'slate' },
};

export const browserTz = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; } catch (e) { return 'UTC'; }
};

export const allTimezones = () => {
  try { return Intl.supportedValuesOf('timeZone'); } catch (e) {
    return ['UTC', 'Asia/Kolkata', 'Asia/Dubai', 'Asia/Singapore', 'Europe/London', 'Europe/Berlin', 'America/New_York', 'America/Chicago', 'America/Los_Angeles', 'Australia/Sydney'];
  }
};

export const asDate = (iso) => new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso}Z`);

export const fmtSlot = (iso, tz, opts = {}) => (iso ? asDate(iso).toLocaleString(undefined, {
  timeZone: tz, weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', ...opts,
}) : '—');

export const fmtTime = (iso, tz) => asDate(iso).toLocaleTimeString(undefined, { timeZone: tz, hour: 'numeric', minute: '2-digit' });

export const dayKey = (iso, tz) => asDate(iso).toLocaleDateString('en-CA', { timeZone: tz });

export const fmtDay = (iso, tz) => asDate(iso).toLocaleDateString(undefined, { timeZone: tz, weekday: 'short', day: 'numeric', month: 'short' });

export const isPast = (iso) => !!iso && asDate(iso).getTime() < Date.now();

export const absUrl = (path) => (path ? `${window.location.origin}${path}` : '');
